import { MyCohortPreviewMember } from '@platform/client/schemas';
import { ProAvatarArray } from './ProAvatarArray';
import { Button, Icon } from '@platform/components';
import { Link } from 'wouter';
import { ROUTES } from '../../routes/consts';

export const PanelFooter = ({
  members,
  totalCount,
}: {
  members: MyCohortPreviewMember[];
  totalCount: number;
}) => {
  return (
    <div className='flex flex-col lg:flex-row justify-between items-center border-t border-gray-100 pt-3.5 pb-4  px-5'>
      <ProAvatarArray members={members} totalCount={totalCount} />
      <Link
        className='text-brand-500 font-semibold text-base hidden lg:flex items-center gap-1 hover:underline'
        to={ROUTES.MY_COHORT}
      >
        See who's in your cohort
        <Icon type='arrow-right' size='16' stroke='brand-500' />
      </Link>
      <Button
        variant='secondary-gray'
        additionalClassnames='lg:hidden mt-2 w-full'
        // we need to review button as link and our routing in general
        href={ROUTES.MY_COHORT}
        size='lg'
      >
        See who's in your cohort
        <Icon type='arrow-right' size='16' />
      </Button>
    </div>
  );
};
